module.exports = __webpack_public_path__ + "static/img/pic_idcard_zm.ab700253.png";